import Vue from 'vue'
import App from './App.vue'
import { store } from './store/index'
import router from './router'
import quasar from './quasar'

import SimpeVueValidation from 'simple-vue-validator'

import moment from "moment-timezone"
import VueMomentJS from "vue-momentjs"

Vue.config.productionTip = false

Vue.use(SimpeVueValidation)
Vue.use(VueMomentJS, moment)


new Vue({
  quasar,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
